import React from 'react';
import './Footer.css';
import logo from '../assets/icon1.png'; // Remplacez par le chemin de votre logo


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo et description */}
        <div className="footer-section">
          <img src={logo} alt="Trinity Logo" className="footer-logo" />
          <p className="footer-description">
            Plate-forme tout en un de shopping moderne et pratique.
          </p>
          <p className="footer-copyright">© Copyright Trinity Inc.</p>
        </div>


        {/* Section Entreprise */}
        <div className="footer-section">
          <h4 className="footer-title">Entreprise</h4>
          <ul className="footer-links">
            <li><a href="#about">À propos de nous</a></li>
            <li><a href="#career">Carrière</a></li>
            <li><a href="#support">Support</a></li>
            <li><a href="#database">Base de données</a></li>
          </ul>
        </div>


        {/* Section Fonctionnalités */}
        <div className="footer-section">
          <h4 className="footer-title">Fonctionnalités</h4>
          <ul className="footer-links">
            <li><a href="#screen-share">Partage d'écran</a></li>
            <li><a href="#app">Application iOS & Android</a></li>
            <li><a href="#file-sharing">Partage de fichiers</a></li>
            <li><a href="#user-management">Gestion des utilisateurs</a></li>
          </ul>
        </div>


        {/* Section Contact */}
        <div className="footer-section">
          <h4 className="footer-title">Nous contacter</h4>
          <ul className="footer-links">
            <li>info@trinityapp.com</li>
            <li>03 55 66 88 89</li>
            <li>95 av parmentier 75011 Paris, Epitech</li>
          </ul>
        </div>


        {/* Section Newsletter */}
        <div className="footer-section">
          <h4 className="footer-title">Rester informé</h4>
          <p>S'abonner à la newsletter</p>
          <form className="footer-form">
            <input
              type="email"
              placeholder="Email"
              className="footer-input"
            />
            <button type="submit" className="footer-button">→</button>
          </form>
        </div>
      </div>
    </footer>
  );
};


export default Footer;
